import getDFPBlock from "../utils/getDFPBlock";

export default function (newsId, elemCount, newsIndex, opt) {
    let wrapperId = 'adv' + newsId + elemCount;
    let advWrapper = document.getElementById(wrapperId);

    if (opt.isMarketplace && opt.subsiteName === 'education') {
        if (advWrapper !== null && advWrapper.childNodes.length === 0) {
            advWrapper.remove();
        }

        return;
    }

    if(advWrapper !== null && advWrapper.childNodes.length === 0){
        if(window.innerWidth < 640){
            getDFPBlock('/56301415/24tv_in_news_mobile_second', [300,250], wrapperId)
        } else {
            getDFPBlock('/56301415/24tv_in_news_desktop_second', [580,400], wrapperId, '580px')
        }
    }
}